/** SwiftSole V3's monthly price, as charged at checkout (PurchaseForm). Used to show rates in dollars. */
export const MONTHLY_PRICE_CENTS = 999

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

/** 12345 → "$123.45"; negatives keep their sign ("-$4.00"). */
export const formatCents = (cents: number | null | undefined) => usd.format((cents || 0) / 100)

/** 2500 → "25%", 1250 → "12.5%". */
export const formatBps = (bps: number | null | undefined) => {
    if (bps == null) return '—'
    const percent = bps / 100
    return `${Number.isInteger(percent) ? percent : percent.toFixed(2).replace(/0+$/, '')}%`
}

/** "25" or "12.5" (percent typed in a form) → basis points. */
export const percentToBps = (percent: string) => Math.round(parseFloat(percent) * 100)

/** "50" or "49.99" (dollars typed in a form) → cents. */
export const dollarsToCents = (dollars: string) => Math.round(parseFloat(dollars) * 100)

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

/**
 * "Oct 19, 2026". Date-only strings ("2026-10-19", as the stats endpoint returns) are calendar days, so they're
 * shown as-is rather than shifted into the viewer's time zone; full timestamps use local time.
 */
export const formatDay = (iso: string | null | undefined) =>
    iso
        ? new Date(iso).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              timeZone: DATE_ONLY.test(iso) ? 'UTC' : undefined,
          })
        : '—'
